import React, { useEffect, useState } from "react";
import $ from "jquery";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import { useTranslation } from "react-i18next";

import { images } from "./imagesToLoad";

import Header from "./components/Header";
import Footer from "./components/Footer";

import Home from "./pages/Home";
import CompositeReinforcement from "./pages/CompositeReinforcement";
import CompositeMesh from "./pages/CompositeMesh";
import MansoryMesh from "./pages/MansoryMesh";
import AboutUs from "./pages/AboutUs";
import Form from "./components/Form";
import PageWrapper from "./PageWrapper";
import Page from "./Page";
import Calculator from "./pages/Calculator";
import News from "./pages/News";

function AnimatedRoutes() {
  const location = useLocation();

  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route
          path="/"
          element={
            <Page title="CompCore | Main Page">
              <PageWrapper>
                <Home />
              </PageWrapper>
            </Page>
          }
        />
        <Route
          path="/composite-rein"
          element={
            <Page title="CompCore | Composite Reinforcement">
              <PageWrapper>
                <CompositeReinforcement />
              </PageWrapper>
            </Page>
          }
        />
        <Route
          path="/composite-mesh"
          element={
            <Page title="CompCore | Composite Mesh">
              <PageWrapper>
                <CompositeMesh />
              </PageWrapper>
            </Page>
          }
        />
        <Route
          path="/masonry-mesh"
          element={
            <Page title="CompCore | Masonry Mesh">
              <PageWrapper>
                <MansoryMesh />
              </PageWrapper>
            </Page>
          }
        />
        <Route
          path="/about-us"
          element={
            <Page title="CompCore | About Us">
              <PageWrapper>
                <AboutUs />
              </PageWrapper>
            </Page>
          }
        />
        <Route
          path="/form"
          element={
            <Page title="CompCore | Form">
              <PageWrapper>
                <Form />
              </PageWrapper>
            </Page>
          }
        />
        <Route
          path="/calculator"
          element={
            <Page title="CompCore | Calculator">
              <PageWrapper>
                <Calculator />
              </PageWrapper>
            </Page>
          }
        />
        <Route
          path="/news"
          element={
            <Page title="CompCore | News">
              <PageWrapper>
                <News />
              </PageWrapper>
            </Page>
          }
        />
      </Routes>
    </AnimatePresence>
  );
}

function App() {
  const { i18n } = useTranslation();
  const isArabic = i18n.language === "ar";

  const [isLoading, setIsLoading] = useState(true);
  const [progress, setProgress] = useState(0);
  const [fadeOutLoader, setFadeOutLoader] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  // Функция показа прелоадера (повторное использование)
  const runPreloader = () => {
    $("body").addClass("ovf-hidden");
    setIsLoading(true);
    setFadeOutLoader(false);
    setProgress(0);

    const minVisibleTime = 1000; // минимум 1 секунда
    const startTime = Date.now();
    let currentProgress = 0;

    // имитация плавного прогресса (без загрузки картинок)
    const timer = setInterval(() => {
      currentProgress += 5;
      if (currentProgress > 90) currentProgress = 90;
      setProgress(currentProgress);
    }, 80);

    const finish = () => {
      clearInterval(timer);
      const elapsed = Date.now() - startTime;
      const delay = Math.max(0, minVisibleTime - elapsed);
      setTimeout(() => {
        setProgress(100);
        setFadeOutLoader(true);
        setTimeout(() => {
          setIsLoading(false);
          $("body").removeClass("ovf-hidden");
        }, 500);
      }, delay);
    };

    // Если первый запуск — грузим картинки
    if (!window.__imagesPreloaded) {
      const total = images.length;
      let loaded = 0;
      const promises = images.map(
        (src) =>
          new Promise((resolve, reject) => {
            const img = new Image();
            img.src = src;
            img.onload = resolve;
            img.onerror = reject;
          }).finally(() => {
            loaded++;
            setProgress(Math.round((loaded / total) * 100));
          })
      );

      Promise.allSettled(promises).then(() => {
        window.__imagesPreloaded = true;
        finish();
      });
    } else {
      // при смене языка без загрузки картинок
      setTimeout(finish, 1200);
    }
  };

  useEffect(() => {
    // первый запуск
    runPreloader();

    // при смене языка
    const onLangChange = () => runPreloader();
    i18n.on("languageChanged", onLangChange);
    return () => i18n.off("languageChanged", onLangChange);
  }, []);
  
    // if (isLoading) return <div id="loader">Loading...</div>;

  return (
    <>
  
    <Router>
      {/* Прелоадер */}
      {isLoading && (
        <div
          id="loader"
          className={`fixed top-0 left-0 w-full h-full bg-black z-[999] flex flex-col items-center justify-center transition-opacity duration-500 ${
            fadeOutLoader ? "opacity-0 pointer-events-none" : "opacity-100"
          }`}
          style={{ fontFamily: "'Open Sans', sans-serif" }}
        >
          <div className="text-white mb-4 text-lg">Loading: {progress}%</div>
          <div className="w-1/2 bg-[#1D1D1D] rounded overflow-hidden">
            <div
              className="bg-[#F26522] h-2 transition-all duration-300"
              style={{ width: `${progress}%` }}
            />
          </div>
        </div>
      )}

      <Header menuOpen={menuOpen} setMenuOpen={setMenuOpen} isArabic={isArabic} />

      <div
        className={`transition-transform duration-300 bg-[#1D1D1D] ${
          menuOpen
            ? isArabic
              ? "translate-x-[300px]"
              : "translate-x-[-300px]"
            : ""
        }`}
        style={{
          transform: menuOpen
            ? isArabic
              ? "translateX(300px)"
              : "translateX(-300px)"
            : "translateX(0)",
        }}
      >
        <AnimatedRoutes />
        <Footer />
      </div>
    </Router>
      </>
  );
}

export default App;
